import { component } from 'picoapp';
import Swiper, { EffectFade, Autoplay } from 'swiper';

export default component(async (node, ctx) => {
  /**
   * Elements
   */
  const sliderElement = node.querySelector('.js-slider');
  const sliderWrapper = node.querySelector('.js-sliderWrapper');
  const section = node.closest('#shopify-section-announcement');

  /**
   * Sticky-then-hide on scroll
   * The bar stays pinned at the top on load. On the first downward scroll it
   * slides out of view upward and stays hidden for the rest of the session.
   */
  let lastScrollPos = window.scrollY;
  let hiddenOnScroll = false;

  const hide = () => {
    hiddenOnScroll = true;

    // Pin the current height so it can transition down to 0 (auto -> 0 won't
    // animate). Collapsing the height reflows the page so no gap is left.
    section.style.height = `${section.offsetHeight}px`;
    void section.offsetHeight; // force reflow before collapsing
    section.classList.add('is-hidden'); // slides the bar up
    section.style.height = '0px'; // collapses the reserved space

    // Keep it hidden for the rest of the session, matching the close button.
    sessionStorage.setItem('topbar', 'closed');
  };

  const handleScroll = () => {
    if (hiddenOnScroll || !section) return;

    const currentScrollPos = window.scrollY;

    if (currentScrollPos > lastScrollPos && currentScrollPos > 0) {
      hide();
    }

    lastScrollPos = currentScrollPos;
  };

  /**
   * Functions
   */
  const initSlider = () => {
    let slider;

    const reset = () => {
      if (slider?.destroy) {
        slider.destroy();
      }

      const isOverflowing = sliderElement.scrollWidth > sliderElement.getBoundingClientRect().width;

      sliderWrapper.classList[isOverflowing ? 'remove' : 'add']('justify-center');

      slider = new Swiper(sliderElement, {
        modules: [EffectFade, Autoplay],
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        speed: 1000,
        loop: true,
      });
    };

    reset();
    // window.addEventListener('resize', reset);
  };

  const init = () => {
    initSlider();

    if (section) {
      ctx.on('window:scroll', handleScroll);
    }
  };

  init();
});
